import PropTypes from 'prop-types';
import React from 'react';
import SuccessPopup from '../../../components/Elements/PopUp/SuccessPopup/SuccessPopup';
import InvitationWidget from '../../../components/InvitationWidget/InvitationWidget';
import Layout from '../../../components/Layout/Layout';
import { SnowplowPageViewTracker } from '../../../components/Analytics/Snowplow/SnowplowPageViewTracker';

import './InviteConnections.scss';

export default class InviteConnections extends React.Component {
    constructor(props) {
        super();
        this.state = {
            postSuccessful: false,
            redirectUrl: props.redirectUrl,
        };
    }

    componentDidMount() {
        if (window && window.document && window.document.referrer) {
            this.setState({
                redirectUrl: window.document.referrer,
            });
        }
    }

    setSuccess = () => {
        this.setState({
            postSuccessful: true,
        });
    };

    showSuccessPopup = () => {
        return this.state.postSuccessful ? (
            <SuccessPopup
                title="Sent!"
                buttonOnClick={this.closePopup}
                cancelButtonOnClick={this.closePopup}
                buttonText="Got it"
            />
        ) : null;
    };

    closePopup = () => {
        if (window) {
            window.open(this.props.redirectUrl, '_self');
        }
    };

    renderCorrectWidget = () => {
        const { redirectUrl } = this.state;

        return (
            <div className="full-gray-background">
                <div className="new-controlled-width-container">
                    <InvitationWidget
                        onCloseRedirectUrl={redirectUrl}
                        isModal={false}
                    />
                </div>
            </div>
        );
    };

    render() {
        return (
            <div className="page-User-InviteConnections">
                <SnowplowPageViewTracker />
                <Layout
                    PAGE_PROPS={this.props.PAGE_PROPS}
                    hasChangingContainer={false}
                >
                    {this.renderCorrectWidget()}
                    {this.showSuccessPopup()}
                </Layout>
            </div>
        );
    }
}

InviteConnections.propTypes = {
    redirectUrl: PropTypes.string,
    PAGE_PROPS: PropTypes.shape().isRequired,
};

InviteConnections.defaultProps = {
    redirectUrl: '/users/connections',
};
